import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_55: FaireProductEntity = {
  token: "catalog_prod_prod-55",
  type: "product",
  name: "Ascent Deco Sculpture - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 85.72,
  msrpDollars: 214.3,
  sku: "JA0055",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 134,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_mens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
